import AddressSelectionRedirectStore from "../stores/AddressSelectionRedirectStore";
import { buildQuery } from "./RequestUtil";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Hook, SessionStore } from "global-modules";

function getRedirectParam(path: string): string {
    if (typeof path?.valueOf() === "string" && path.length > 0) {
        if (path.startsWith("/")) {
            path = path.substring(1);
        }
        return encodeURIComponent(path);
    } else {
        return "";
    }
}

/**
 * returns a string that can be used for router.transitionTo.
 *
 * The passed param is assumed to not be url-encoded, because react-router takes care of url-decoding.
 */
export function getPathFromRedirectParamWithDefault(
    redirectParam: string | undefined | null,
    defaultValue: string
): string {
    if (redirectParam) {
        return "/" + redirectParam;
    }
    return "/" + defaultValue;
}

export function cleanUpUrlForRedirect(uncleandUrl: string): string {
    // for local testing add betty-pp -> localhost to /etc/hosts and have unifiedapi on port 80
    return uncleandUrl.replace("/testLoginIdam", "/exlogin").replace(/^http:/, "https:");
}

/** Result of a hook that basically says the hook did nothing */
const HOOK_SKIPPED = { checkNext: true, didRedirect: false };

function properStoreSelected(SessionStore: SessionStore) {
    return (
        SessionStore.getCustomerStore() &&
        (AddressSelectionRedirectStore.hasRedirectedForFsdCustomer() ||
            AddressSelectionRedirectStore.fsdCustomerHasSuitableAddressSelected())
    );
}
const noSelectAddressPaths = /^\/(selectAddress|selectAccount|customersearch|backoffice\/customer\/search)/;
export const selectAddress: Hook = function (state, SessionStore, Handler) {
    const correctedPath = cleanUpUrlForRedirect(state.path);
    const forceSelection = state.query && (state.query.setStoreId || state.query.setAddressId);
    const storeSelectionNecessary =
        !state.routeParams.noCustomerNeed && SessionStore.loggedIn() && !properStoreSelected(SessionStore);
    if (
        !SessionStore.pending() &&
        !noSelectAddressPaths.exec(correctedPath) &&
        (storeSelectionNecessary || forceSelection)
    ) {
        const { setStoreId, setAddressId, useFirstAddress, ...rest } = state.query ?? {};
        const redirectQuery = buildQuery(rest);
        const redirectTo =
            "/selectAddress/" +
            getRedirectParam(correctedPath + (redirectQuery.length > 0 ? "?" + redirectQuery : "")) +
            (window.location.hash ?? "");
        Handler.transitionTo(redirectTo, state.query);
        AddressSelectionRedirectStore.setStateOnRedirect();
        return { checkNext: false, didRedirect: true };
    }

    return HOOK_SKIPPED;
};
